import { useState, useEffect } from "react";
import SalesforceFieldError from "./SalesforceFieldError";
const { normalizeSalesforceValue } = require("../shared/salesforceDiploma");
const { PREDEFINED_OPTIONS: listePredef } = require("../shared/selectOptions");
const { buildQuestionLookup, isQuestionVisible } = require("../shared/progress");

export default function QuestionSelect({ questionInfo, getNumberFiliereActif, getNumberCritereActif, updateQuestionValue, updateQuestionVisible, updateQuestionSelectPays, sousCritereIndex, questionIndex, data, updateFiltreGeneral, sendDataToServer, paymentExists }) {

  /* ------------------------------------------------------------ STATE ------------------------------------------------------------ */

  const [value, setValue] = useState(normalizeSalesforceValue(questionInfo.idForm, questionInfo.value));

  const currentPeriod = data?.data?.[getNumberFiliereActif];
  const questionLookup = buildQuestionLookup(currentPeriod);
  const questions = data.data[getNumberFiliereActif].criteres[getNumberCritereActif].sousCriteres[sousCritereIndex].questions;
  const visible = isQuestionVisible(questionInfo, {
    dataFiltres: currentPeriod?.filtres,
    questionLookup
  });


  useEffect(() => {
    // Écouter les changements dans le localStorage
    const handleStorageChange = (event) => {
      if (event.key === "questionDataUpdate") {
        // Recharger les données à partir du localStorage
        const updatedData = JSON.parse(event.newValue);
        updateLocalState(updatedData);
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setValue(normalizeSalesforceValue(questionInfo.idForm, questionInfo.value) ?? "");
  }, [questionInfo.idForm, questionInfo.value]);

  /* ------------------------------------------------------------ COMPORTEMENT ------------------------------------------------------------ */

  useEffect(() => {
    try {
      const currentQuestion = questions?.[questionIndex];
      const currentVisible =
        typeof currentQuestion?.visiblepourcentage === "boolean"
          ? currentQuestion.visiblepourcentage
          : (typeof currentQuestion?.visible === "boolean" ? currentQuestion.visible : true);
      if (currentVisible !== visible) {
        updateQuestionVisible(getNumberCritereActif, sousCritereIndex, questionIndex, visible);
      }
    } catch {
    }
    checkDependance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, getNumberFiliereActif, getNumberCritereActif, sousCritereIndex, questionIndex, visible]);

  function getFirstOptionValue(question) {
    const options = typeof question?.Options === "number"
      ? listePredef[question.Options]
      : question?.Options;
    if (!Array.isArray(options) || options.length === 0) return "";
    const [firstOption] = options;
    return firstOption?.value ?? "";
  }

  /* eslint-disable no-loop-func */
  function checkDependance() {
    let visibles;
    let NumDependance = 0;
    let ValueDependance = 0;
    let NumDependance2 = 0;
    let ValueDependance2 = 0;

    for (let i = 0; i < questions.length; i++) {
      try {
        const currentQuestion = questions[i];

        if (currentQuestion.Dépendance && currentQuestion.Dépendance.length >= 2) {
          NumDependance = currentQuestion.Dépendance[0];
          ValueDependance = currentQuestion.Dépendance[1];

          const questionDependante = questionLookup.get(String(NumDependance));
          if (!questionDependante) continue;

          visibles = questionDependante.value === ValueDependance;

          // Si Dépendance2 existe, on ajoute la vérification
          if (currentQuestion.Dépendance2 && currentQuestion.Dépendance2.length >= 2) {
            NumDependance2 = currentQuestion.Dépendance2[0];
            ValueDependance2 = currentQuestion.Dépendance2[1];

            const questionDependante2 = questionLookup.get(String(NumDependance2));
            if (!questionDependante2) continue;

            visibles = visibles && (questionDependante2.value === ValueDependance2);
          }

          const currentVisible =
            typeof currentQuestion.visiblepourcentage === "boolean"
              ? currentQuestion.visiblepourcentage
              : (typeof currentQuestion.visible === "boolean" ? currentQuestion.visible : true);
          const element = document.getElementById("id:" + currentQuestion.id);
          if (element) {
            element.style = visibles ? "display:block" : "display:none";
            if (!visibles) {
              const hiddenValue = currentQuestion.defaultWhenHidden === "firstOption"
                ? getFirstOptionValue(currentQuestion)
                : "";
              if (currentQuestion.value !== hiddenValue) {
                currentQuestion.value = hiddenValue;
                if (i === questionIndex) {
                  setValue(hiddenValue);
                }
              }
            } else if (
              currentQuestion.defaultWhenHidden === "firstOption"
              && currentVisible === false
              && currentQuestion.value === getFirstOptionValue(currentQuestion)
            ) {
              if (currentQuestion.value !== "") {
                currentQuestion.value = "";
                if (i === questionIndex) {
                  setValue("");
                }
              }
            }
          }
          if (currentVisible !== visibles) {
            updateQuestionVisible(getNumberCritereActif, sousCritereIndex, i, visibles);
          }
        }

      } catch (error) {
        console.error("Erreur dans checkDependance pour la question index " + i + " :", error);
      }
    }
  }

  // checkDependance();
  /* eslint-disable no-loop-func */

  const nationalitesEuropeennes = [
    "Allemande", "Autrichienne", "Belge", "Bulgare", "Chypriote, Cypriote",
    "Croate", "Danoise", "Espagnole", "Estonienne", "Finlandaise",
    "Grec - Grecque", "Hongroise", "Irlandaise", "Italienne", "Lettonne",
    "Lituanienne", "Luxembourgeoise", "Maltaise", "Néerlandaise", "Polonaise",
    "Portugaise", "Roumaine", "Slovaque", "Slovène", "Suédoise", "Tchèque"
  ];

  const handleChange = async (event) => {
    const newValue = event.target.value;
    setValue(newValue);
    const updatedData = updateQuestionValue(sousCritereIndex, questionIndex, newValue);

    if (event.target.options[event.target.selectedIndex].getAttribute('code')) {
      const newCode = event.target.options[event.target.selectedIndex].getAttribute('code');
      updateQuestionSelectPays(sousCritereIndex, questionIndex, newValue, newCode);
    }

    if (data?.configuration !== 'Echange' && questionInfo.id === 1110) {
      let nationaliteNormalisee = "Étrangère";

      if (newValue === "Française") {
        nationaliteNormalisee = "Française";
      } else if (nationalitesEuropeennes.includes(newValue)) {
        nationaliteNormalisee = "Européenne";
      }

      //console.log("Nationalité normalisée :", nationaliteNormalisee);
      updateFiltreGeneral(nationaliteNormalisee, 4);

      // Tu peux maintenant utiliser cette variable comme tu veux :
      // - la stocker dans le state global
      // - la transmettre à une autre fonction
      // - déclencher une autre logique
    }


    if (data?.configuration !== 'Echange' && questionInfo.id === 513 && String(currentPeriod?.filtres?.[5] || "").trim().toLowerCase().startsWith("alternance") && newValue === "Oui" && paymentExists === true) {
      if (sendDataToServer && updatedData) {
        await sendDataToServer(updatedData);
      }
      window.location.reload();
    }
  };

  function updateLocalState(updatedData) {
    if (updatedData.sousCritereIndex === sousCritereIndex && updatedData.questionIndex === questionIndex) {
      setValue(updatedData.newValue);
    }
  }

  /* ------------------------------------------------------------ AFFICHAGE ------------------------------------------------------------ */

  if (!visible) return null;

  const isAcceptanceReminder = questionInfo.nom === "Acceptation"
    && typeof questionInfo.etiquette === "string"
    && questionInfo.etiquette.toLowerCase().includes("contrat étudiant");

  const acceptancePaymentReminderText = `Le déclarant est informé que les documents et informations transmis sont certifiés exacts et complets. Toute fausse déclaration ou omission engage la responsabilité de son auteur et est susceptible d'entraîner des sanctions.

⚠️ POUR LES ALTERNANTS : aucun paiement n'est requis. Veuillez consulter la procédure ci-dessous selon votre situation.

1) Inscription ou réinscription avec un nouveau contrat d'alternance
Vérifiez attentivement votre dossier avant de répondre « Oui » à la question ci-dessous.
Contactez le 02 51 46 12 13 et demandez le service des facultés afin que le paiement soit désactivé et que vous puissiez poursuivre votre inscription. 

2) Réinscription avec poursuite du même contrat d'alternance
Vérifiez attentivement votre dossier avant de répondre « Oui » à la question ci-dessous.

Attention : après validation de votre réponse, votre dossier sera immédiatement verrouillé et basculera automatiquement vers la signature électronique des documents d'inscription. Aucune modification ne pourra être effectuée.`;

  return (
    <div className="question" id={"id:" + questionInfo.id} style={{ display: "block" }}>
      <label className="questionTitle">
        {questionInfo.etiquette} :{questionInfo.required === "required" ? " *" : ""}
      </label>
      <div>
        {!isAcceptanceReminder && (
          <div className="QuestionHelp" dangerouslySetInnerHTML={{ __html: questionInfo.QuestionHelp }} />
        )}
        {isAcceptanceReminder ? (
          <div className="paymentReminder" role="note" aria-live="polite">
            <p className="paymentReminderText">{acceptancePaymentReminderText}</p>
          </div>
        ) : null}
        {isAcceptanceReminder && questionInfo.QuestionHelp ? (
          <div className="acceptanceReminder" role="note" aria-live="polite">
            <p className="acceptanceReminderText" dangerouslySetInnerHTML={{ __html: questionInfo.QuestionHelp }} />
          </div>
        ) : null}
        {/*Affiche la liste et options contenu dans la questionInfo*/}
        <select
          id={questionInfo.idForm}
          name={questionInfo.idForm}
          type={questionInfo.type}
          className="text"
          required={questionInfo.required}
          placeholder={questionInfo.placeholder}
          pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
          value={value}
          onChange={handleChange}
        >
          <option key={0} value="">{data?.configuration === 'Echange' ? 'Select an option' : '-'}</option>
          {(typeof questionInfo.Options === "number" ? listePredef[questionInfo.Options] : questionInfo.Options).map((option) => {
            const optionValue = option?.value ?? "";
            const isDisabled = String(optionValue).toLowerCase().includes("disabled");
            return (
              <option
                key={option.id}
                value={optionValue}
                code={option.code}
                disabled={isDisabled}
              >
                {option.text}
              </option>
            );
          })}
        </select>
        {/* Refus du CRM lors de l'envoi. Les listes déroulantes concentrent la
            plupart des rejets (valeur hors liste), or ce composant n'affichait
            aucune erreur jusqu'ici : le candidat ne voyait rien. */}
        <SalesforceFieldError error={questionInfo.salesforceError} />
      </div>

    </div>
  );

}
